import { render } from "./BurgherMenu.vue?vue&type=template&id=c9ee0674"
import script from "./BurgherMenu.vue?vue&type=script&lang=js"
export * from "./BurgherMenu.vue?vue&type=script&lang=js"

import "./BurgherMenu.vue?vue&type=style&index=0&id=c9ee0674&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__